import styled from 'styled-components'
import HeroHome from 'src/components/Hero/Home'

import MainLayout from '../../layouts/MainLayout'

export const Layout = styled(MainLayout)``

export const Hero = styled(HeroHome)``
